document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('.section-hero').forEach(video => {
    const playFcn = video.querySelector('.button-play');
    const pauseFcn = video.querySelector('.button-pause');
    const desktopVideo = video.querySelector(".primary-hero--video_desktop");
    const desktopMobile = video.querySelector(".primary-hero--video_mobile");
  
    if(playFcn) {
      playFcn.addEventListener('click', function(e) {
        e.preventDefault();
        desktopVideo.play();
        desktopMobile.play();
        playFcn.classList.remove("is-active");
        pauseFcn.classList.add("is-active");
      });    
    }
    
    if(pauseFcn) {
      pauseFcn.addEventListener('click', function(b) {
        b.preventDefault();
        desktopVideo.pause();
        desktopMobile.pause();
        pauseFcn.classList.remove("is-active");
        playFcn.classList.add("is-active");
      }); 
    }
  });
});
